import { tv } from '~/utils/tv'

export const labelStyles = tv({
  base: [
    'line-clamp-1 max-w-full truncate',
    'font-normal font-sans text-[var(--color-text-neutral-default)] data-[disabled]:text-[var(--color-text-neutral-disabled)]',
  ],
  variants: {
    size: {
      md: 'text-[length:var(--font-size-threepulse)] leading-[var(--line-height-medium)]',
      ml: null,
      lg: null,
      xl: null,
    },
  },
  compoundVariants: [
    {
      size: ['ml', 'lg', 'xl'],
      class:
        'text-[length:var(--font-size-threeandhalfpulse)] leading-[var(--line-height-small)]',
    },
  ],
  defaultVariants: {
    size: 'ml',
  },
})
